// Role shown for a user in the Users table / detail header. The global role
// (user.role) only exists for internal/ops users; tenant members created via
// "New user" hold their role per company in user_companies[].role, so fall
// back to those (distinct names, comma-joined).
export function userRoleLabel(user) {
  if (user?.role?.name) return user.role.name
  const names = [
    ...new Set((user?.user_companies ?? []).map((c) => c.role?.name).filter(Boolean)),
  ]
  return names.length ? names.join(', ') : null
}
